let Buffer = require('buffer/').Buffer

const deviceTypeName = {
  1: 'Ksk',
  2: 'Om',
  3: 'Pos',
  1000: 'App'
}

function composeFruitItemLocal(sizeExtID, count, modositok, elvitel, extraModos, idoszakosAr) {
  return {
    termekkiszerelesid: sizeExtID,
    darab: count,
    kor: -1,
    vendeg: 1,
    modositok: modositok,
    elvitel: elvitel,
    extra_modos: extraModos,
    idoszakos_ar: '' + (+idoszakosAr).toFixed(2) // A mi eladasi egységárunk - kedvezményekkel egyutt
  }
}

function calculateCountAndAddConnectedItems(connectedItems, count) {
  for (let item of connectedItems) {
    item.darab = item.darab * count
  }
  return connectedItems
}

function calculatePriceOfConnectedItems(connectedItems, count) {
  let connectedItemsValue = 0
  for (let item of connectedItems) {
    let cnt = +item.darab * +count
    connectedItemsValue += (cnt * +item.idoszakos_ar)
  }
  return connectedItemsValue
}

function composeFruitOrderFormatLocal(order, items, location) {
  //console.log('composeFruitOrderFormatLocal', order, items, location)
  if (!location?.localConfig?.fruit) {
    return { success: true, message: 'Fruitsys not configured' }
  }
  let { apiKey = '', gepID = 0, helyszinID = 0, userID = 1, sendTableAsTable = 0, deliveryItemExtID = 0 } = location?.localConfig?.fruit || {}

  let rendelesek = []
  let fizetve = null
  let invoiced = 0
  let preName = deviceTypeName[order.insertDeviceType] || 'Oke'
  let orderIdentifier = order.orderIdentifier == null ? '' : (order.orderIdentifier + "")
  let orderNumber = order.orderNumber == null ? '' : (order.orderNumber + "")
  let comment = ''
  let asztal = ''
  let asztalid = -2
  if (orderIdentifier.length > 0) {
    asztal += 'I:' + orderIdentifier
  }
  if (order.tableInfo != null) {
    comment = 'T: ' + order.tableInfo.name + '\n '
    asztal += 'T: ' + order.tableInfo.name
    if (sendTableAsTable && order.paymentsNeeded !== 0) {
      asztalid = order.tableInfo.extID
    }
  }
  let buff = Buffer.from(asztal)
  let asztalnev = buff.toString('base64')

  comment += preName + ': #' + orderNumber + (orderIdentifier.length > 0 ? ' I:' + orderIdentifier : '') + '\n '
  if (order.paymentsNeeded !== 0) {
    comment += ' # NINCS FIZETVE # ' + '\n'
  }
  if (order.notes != null && order.notes.length > 0) {
    comment += 'M: ' + order.notes + '\n'
  }
  //console.log(comment)
  if (order.paymentsNeeded === 0) {
    fizetve = 2
    invoiced = 1
  }

  let errors = []

  for (const item of Object.values(items)) {
    let takeAway = item.takeAway == null ? order.takeAway : item.takeAway
    let connectedItems = []
    let modositok = []
    if (item.count > 0 && item.sizeExtID != null && item.sizeExtID !== '' && (item.sizeExtID + '' !== '0')) {
      let elvitel = null
      let megjegyzes = ''
      if (takeAway) {
        megjegyzes = '### ELVITELRE ###\n'
        elvitel = 1
      }
      let discountRatio = item.sumDiscountPrice / item.sumPrice
      let modifiersPrice = 0
      for (let mg of item.modifierGroups || []) {
        for (const modifier of mg.modifiers || []) {
          if ((+modifier.count > 0) && modifier.extID != null && modifier.extID !== '' && (modifier.extID + '' !== '0')) {
            if (modifier.extIDType === 'ITEM') {
              let megjegyzesBuffer = Buffer.from(megjegyzes)
              let megjegyzesBase64 = megjegyzesBuffer.toString('base64')
              let itemPrice = Math.round(modifier.price * discountRatio)
              let fruitItem = composeFruitItemLocal(modifier.extID, modifier.count, [], elvitel, megjegyzesBase64, itemPrice)
              connectedItems.push(fruitItem)
            } else {
              let fruitModifier = {
                modositoid: modifier.extID,
                modcsoportid: '',
                darab: modifier.count,
                felar: Math.round(modifier.price * discountRatio)
              }
              modifiersPrice += (modifier.count * Math.round(modifier.price * discountRatio))
              modositok.push(fruitModifier)
            }
          } else {
            //console.log('incorrect')
          }
        }
      }
      if (item.notes == null) item.notes = ''
      let megjegyzesBuffer = Buffer.from(megjegyzes + item.notes)
      let megjegyzesBase64 = megjegyzesBuffer.toString('base64')

      // Add the item
      // Check package price
      let packagePrice = item.packageDiscountPrice
      let packageExtID = (takeAway ? item?.package?.taExtID : item?.package?.extID) || null

      // Add package
      if (packagePrice != null && packageExtID != null) {
        let fruitModifier = {
          modositoid: packageExtID,
          modcsoportid: '',
          darab: 1,
          felar: packagePrice
        }
        modositok.push(fruitModifier)
        // modifiersPrice += packagePrice
      }

      let connectedItemsPrice = calculatePriceOfConnectedItems(connectedItems, 1)
      //console.log(item)
      //console.log(item.sumDiscountPrice, item.count, connectedItemsPrice, modifiersPrice, item.serviceFee)
      let itemPrice = Math.round((item.sumDiscountPrice / item.count) - connectedItemsPrice) - modifiersPrice + item.serviceFee

      let fruitItem = composeFruitItemLocal(item.sizeExtID, item.count, modositok, elvitel, megjegyzesBase64, itemPrice)

      // ===
      rendelesek.push(fruitItem)
      rendelesek = rendelesek.concat(calculateCountAndAddConnectedItems(connectedItems, item.count))
    } else {
      if(!(item.sizeExtID?.length > 0)) {
        errors.push(`${item.name?.hu || 'N/A'} (${item.uuid})`)
      }
    }
  }

  if (order.deliveryCost > 0) {
    let fruitItem = composeFruitItemLocal(deliveryItemExtID || '-5579', 1, [], 1, '', order.deliveryCost)
    rendelesek.push(fruitItem)
  }

  let res = {
    rendelesek: rendelesek,
    asztalid: asztalid,
    gepid: gepID,
    helyszinid: helyszinID,
    userid: userID,
    apikey: apiKey,
    version: '1.0',
    asztalnev: (asztalid == -2 ? asztalnev : null),
    fizetve: null,
    invoiced: invoiced,
    kioszk: 1,
    uuid: order.uuid,
    comment: comment
  }
  if(errors.length > 0) {
    return { success: false, message: "These items dont have extIDs", data: errors }
  } else {
    return { success: true, res }
  }
}

async function sendOrderToFruitsysLocal(order, items, location, sendMessageToWebView) {
  if(sendMessageToWebView == null) return
  let fruitOrder = composeFruitOrderFormatLocal(order, items, location)
  if(!fruitOrder.success) {
    return fruitOrder
  }
  let ipAddress = location?.localConfig?.fruit?.serverIP
  let res = await sendMessageToWebView({
    action: 'fruitsysOrderSend',
    data: { fruitOrder: fruitOrder.res, ipAddress }
  })
  if(res?.data?.data?.rendelesszam === 0) {
    res.data.success = false
    res.data.message = 'Order partially sent to Fruitsys'
  }
  return res?.data || { success: false, message: 'No response from webview' }
}

export {
  sendOrderToFruitsysLocal
}
